import type {
  AccessorialCharge,
  FuelSurcharge,
  HighCostZipCode,
  LaneMinimum,
  RateBase,
} from "../../hooks/react-query/backOffice/useGlobalRates";

export const mockRateBases: RateBase[] = [
  {
    id: 1,
    code: "US to US",
    description: "DYLT 2024/8/19, LB, USD",
    effectiveDate: "08/19/2024",
    expirationDate: "02/26/2026",
    sequence: "1",
  },
  {
    id: 2,
    code: "Canada",
    description: "DYLT 2024/8/19, LB, USD",
    effectiveDate: "08/19/2024",
    expirationDate: "12/19/2024",
    sequence: "2",
  },
];

export const mockFuelSurcharges: FuelSurcharge[] = [
  {
    id: 1,
    code: "17881",
    description: "Western Fuel Surcharge",
    effectiveDate: "08/19/2024",
    expirationDate: "12/19/2024",
    sequence: "1",
  },
  {
    id: 2,
    code: "17881",
    description: "National Fuel Surcharge",
    effectiveDate: "08/19/2024",
    expirationDate: "12/19/2024",
    sequence: "2",
  },
];

export const mockAccessorialCharges: AccessorialCharge[] = [
  {
    id: 1,
    scheduleName: "Standard",
    description: "Standard Accessorial",
    effectiveDate: "08/19/2024",
    expirationDate: "12/19/2024",
  },
];

export const mockLaneMinimums: LaneMinimum[] = [
  {
    id: 1,
    scheduleName: "Standard",
    description: "Standard Lane Minimums",
    effectiveDate: "08/19/2024",
    expirationDate: "12/19/2024",
  },
];

export const mockHighCostZipCodes: HighCostZipCode[] = [
  {
    id: 1,
    scheduleName: "Alaska Remote",
    description: "High Cost Zip Codes for Alaska Remote Areas",
    effectiveDate: "08/19/2024",
    expirationDate: "12/31/2025",
  },
  {
    id: 2,
    scheduleName: "Hawaii Islands",
    description: "High Cost Zip Codes for Hawaiian Islands",
    effectiveDate: "08/19/2024",
    expirationDate: "12/31/2025",
  },
  {
    id: 3,
    scheduleName: "Mountain West",
    description: "High Cost Zip Codes for Mountain West Region",
    effectiveDate: "01/01/2025",
    expirationDate: "12/31/2025",
  },
];
